import React, {Component} from 'react';
import {Treebeard} from 'react-treebeard';
import {VelocityComponent} from 'velocity-react';

const style = {  
   tree:{  
      base:{  
         listStyle:'none',
         margin:0,
         padding:0,
         color:'#428BCA',
         fontFamily:'lucida grande ,tahoma,verdana,arial,sans-serif',
         fontSize:'14px'
      },
      node:{  
         base:{  
            position:'relative'
         },
         link:{  
            position:'relative',
            padding:'0px 5px',
            display:'block'
         },
         activeLink: {
            color: "#FAFAFA",
            backgroundColor: "#428BCA",
            //backgroundColor: "#f6f6f6"
         },
         toggle:{  
            base:{  
               position:'relative',
               display:'inline-block',
               verticalAlign:'top',
               marginLeft:'-5px',
            },
            wrapper:{  
               position:'absolute',
               top:'50%',
               left:'50%',
               margin:'-7px 0px 0 -7px',
               height:'14px'
            },
            height:14,
            width:14,
            arrow:{  
               fill:'#428BCA',
               strokeWidth:0
            }
         },
         header:{ 
            base:{  
               display:'inline-block',
               verticalAlign:'top',
               marginLeft: '7px'
            },
            connector:{  
               width:'2px',
               height:'12px',
               borderLeft:'solid 2px black',
               borderBottom:'solid 2px black',
               position:'absolute',
               top:'0px',
               left:'-21px'
            },
            title:{  
               lineHeight:'24px',
               verticalAlign:'middle',
               fontWeight: 'bold',
            },
            titleLeaf: {
              lineHeight:'24px',
               verticalAlign:'middle'
            }
         },
         container: {
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            padding: '2px 12px',
            margin: '5px 0px',
         },
         containerLeaf: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: '2px 12px',
            margin: '5px 0px',
         },
         subtree:{  
            listStyle:'none',
            paddingLeft:'19px'
         },
         loading:{  
            color:'#E2C089'
         }
      }
   }
};

let currentActiveNode = null

class TreeView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentActiveNode: currentActiveNode
    }

    this.decorators = {
      Toggle: ({animations, onClick, style, node}) => {
        if (node.type === "dc") {
          return (
            <i className={"glyphicon glyphicon-link"} />
          )
        } else {
          return (
            <VelocityComponent animation={animations.toggle.animation}
              duration={animations.toggle.duration}
              ref={ref => this.velocityRef = ref}>
              <i className={"glyphicon glyphicon-chevron-right"} />
            </VelocityComponent>
          )
        }
      },

      Header: ({style, node}) => {
        return (
          <div style={style.base}>
            <div style={node.children ? style.title : style.titleLeaf}>
              {node.name}
              {
                node.initialValues.ldap !== undefined && !node.initialValues.ldap &&
                <i title="info" className="glyphicon glyphicon-info-sign" style={{marginLeft: "6px", color: "#E67300", fontSize: "0.9em", cursor: "pointer"}}></i>
              }
            </div>
          </div>
        );
      },

      Container: ({animations, onClick, toggle, style, node}) => {
        let containerStyle = style.containerLeaf;
        if (node.children)
          containerStyle = style.container;
        let activeStyle = node.active ? style.activeLink : null;
        return (
          <div style={{...containerStyle, ...activeStyle, ...{cursor: node.selectable ? "pointer" : "auto"}}} onClick={onClick}>
            <div style={{display: "inline-block"}}>
              <this.decorators.Toggle node={node} style={style.toggle} animations={animations} />
              <this.decorators.Header node={node} style={style.header} />
            </div>
            {node.initialValues.notice && <span className="glyphicon glyphicon-exclamation-sign" style={{color: "#A94442", lineHeight: "1.6"}}></span>}
          </div>
        )
      }
    }
  }

  onToggle = (node, toggled) => {
    if (node.selectable) {
      node.toggled = toggled;

      if (this.state.currentActiveNode){
        let currentActiveNode = this.state.currentActiveNode; //don't mutate state directly
        currentActiveNode.active = false;
      }
      node.active = true;

      currentActiveNode = node;
      this.setState({currentActiveNode: node});

      this.props.update(node);
    }
  } 

  render() {
    return <Treebeard data={this.props.data} onToggle={this.onToggle} decorators={this.decorators} style={style} />
  }
}

export default TreeView;


// WEBPACK FOOTER //
// ./src/Components/SiteManagement/TreeView.js